// extracted by mini-css-extract-plugin
export default {"rating":"ZE-z","numberOfStars":"_E-z","count":"aF-z","barGraphSpacing":"bF-z","barGraph":"cF-z"};